import * as React from 'react';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Typography from '@mui/material/Typography';
import Link from '@mui/material/Link';
import Stack from '@mui/material/Stack';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';

/* __next_internal_client_entry_do_not_use__ default auto */ import { createDemoClient } from '@mui/internal-core-docs/utils/createDemoClient';
const ClientProvider = createDemoClient(import.meta.url, { precompute: { externals: { react: React, "@mui/material/Breadcrumbs": Breadcrumbs, "@mui/material/Typography": Typography, "@mui/material/Link": Link, "@mui/material/Stack": Stack, "@mui/icons-material/NavigateNext": NavigateNextIcon } } });
export default ClientProvider;
